<template>
  <div class="main-menu">
    <div class="container grid-list-md pa-0 fill-height">
      <div class="layout ma-0 row wrap align-center justify-space-between">
        <slot name="leftSide"></slot>

        <div class="main-menu__list hidden-sm-and-down" v-if="items.length">
          <app-btn
            class="menu__item"
            v-for="item in items"
            :key="item.name"
            :to="item.to"
            :href="item.href"
            :exact="item.exact"
            :target="item.target"
            :class="item.extraClass"
            >{{ item.name }}</app-btn
          >
        </div>

        <slot name="rightSide"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    }
  }
};
</script>
